export const DATA_INGESTION_SERVICE_NAMES = [
  { id: 'cloudRiskStress', displayValue: 'Cloud Risk - Stress Testing' },
  { id: 'cloudRiskPriips', displayValue: 'Cloud Risk - PRIIPs' },
  { id: 'fvcStress', displayValue: 'FVC - Stress Testing' },
  { id: 'fvcPriips', displayValue: 'FVC - PRIIPs' },
  { id: 'inspireDocumentationService', displayValue: 'inSPire Documentation Service' },
  { id: 'productImport', displayValue: 'Product Import' },
];
